const w: any = window;

class EventService {
  listeners: [];
  element: any;
  _element = "body"; //this is for custom communication so we'll just listen here.
  _interval: number;
  callbacks: Function[] = [];
  constructor() {
    this.cacheElement();
  }
  cacheElement(): void {
    if (this._interval) {
      return;
    }

    this._interval = window.setInterval(() => {
      if (w.jQuery) {
        window.clearInterval(this._interval);
        this.element = w.jQuery(this._element)
        this.callbacks.forEach((value) => value());
      }
    }, 50);
  }
  on(eventName: string, fn: Function): void {
    if (this.element) {
      this.element.on(eventName, fn);
    } else {
      this.callbacks.push(() => {
        this.on(eventName, fn);
      });
    }
  }

  off(eventName: string, fn: Function): void {
    if (this.element) {
      this.element.off(eventName, fn);
    } else {
      this.callbacks.push(() => {
        this.off(eventName, fn);
      });
    }
  }
}

const eventService = new EventService();

export default eventService;
